// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Lc0t","content":"styles_content__3mi0V","textInputWidthDefault":"styles_textInputWidthDefault__1ydXO","flexButton":"styles_flexButton__20t9g"};